/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function Various(props) {
  return (
    <svg {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.7495 3.24512C15.1976 3.24512 16.6204 3.62663 17.8745 4.35059C18.1065 4.48456 18.2495 4.73211 18.2495 5V15.833C18.2495 16.1009 18.1065 16.3484 17.8745 16.4824C17.6425 16.6162 17.3565 16.6163 17.1245 16.4824C16.0985 15.8902 14.9342 15.5781 13.7495 15.5781C12.5648 15.5782 11.4005 15.8901 10.3745 16.4824C10.1425 16.6162 9.85647 16.6163 9.62451 16.4824C8.5985 15.8902 7.43419 15.5781 6.24951 15.5781C5.06484 15.5782 3.90048 15.8901 2.87451 16.4824C2.64251 16.6162 2.35647 16.6163 2.12451 16.4824C1.89275 16.3484 1.74951 16.1008 1.74951 15.833V5C1.74954 4.73222 1.89269 4.4846 2.12451 4.35059C3.37855 3.62657 4.80148 3.24519 6.24951 3.24512C7.55517 3.24512 8.84012 3.55581 9.99951 4.14746C11.1589 3.55576 12.4439 3.24518 13.7495 3.24512ZM6.24951 4.74512C5.20693 4.74518 4.18004 4.98658 3.24951 5.44824V14.6436C4.2022 14.2717 5.21956 14.0782 6.24951 14.0781C7.27947 14.0781 8.2968 14.2717 9.24951 14.6436V5.44824C8.31895 4.98663 7.2921 4.74512 6.24951 4.74512ZM13.7495 4.74512C12.7069 4.74518 11.68 4.98658 10.7495 5.44824V14.6436C11.7022 14.2717 12.7196 14.0782 13.7495 14.0781C14.7795 14.0781 15.7968 14.2717 16.7495 14.6436V5.44824C15.819 4.98663 14.7921 4.74512 13.7495 4.74512Z"
        fill="#35424F"
      />
    </svg>
  )
}

Various.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default Various
